module.exports = __webpack_public_path__ + "img/godialDialer.e79c9693.png";